import { Button as CoreUIButton, ButtonProps as CoreUIButtonProps } from '@hopskipdrive/react-components';
import cn from 'classnames';

import { StyledButtonSx, TonalButtonSx, TonalVariantButtonSx, WarningButtonSx } from './Button.styles';

export interface ButtonProps extends Omit<CoreUIButtonProps, 'variant' | 'color'> {
  hover?: boolean;
  active?: boolean;
  loading?: boolean;
  color?: 'primary' | 'secondary' | 'tonal' | 'tonal variant' | 'warning';
  variant?: 'text' | 'contained';
}

export const Button = ({ children, hover, active, loading, disabled, variant, color, ...rest }: ButtonProps) => {
  const props = {
    className: cn({
      '-hover': hover,
      '-active': active,
    }),
    disabled: disabled || loading,
  };

  switch (color) {
    case 'tonal':
      return (
        <CoreUIButton sx={TonalButtonSx} {...props} variant="contained" {...rest}>
          {children}
        </CoreUIButton>
      );
    case 'tonal variant':
      return (
        <CoreUIButton sx={TonalVariantButtonSx} {...props} variant="contained" {...rest}>
          {children}
        </CoreUIButton>
      );
    case 'warning':
      return (
        <CoreUIButton sx={WarningButtonSx} {...props} variant="contained" {...rest}>
          {children}
        </CoreUIButton>
      );
    default:
      return (
        <CoreUIButton
          sx={StyledButtonSx}
          {...props}
          variant={variant || 'contained'}
          color={color || 'secondary'}
          {...rest}
        >
          {children}
        </CoreUIButton>
      );
  }
};

Button.defaultProps = {
  loading: false,
  disabled: false,
};
